<div class="details-wrap" *ngIf="!loading && !error; else loadingOrError">
  <!-- Header -->
  <section class="header card">
    <div class="left">
      <h3>Order #{{ details?.publicOrderCode }}</h3>
      <div class="sub">
        <span class="chip">{{ details?.orderStatus | titlecase }}</span>
        <span class="dot" aria-hidden="true">•</span>
        <span class="chip alt">{{
          details?.orderType || "-" | titlecase
        }}</span>
      </div>
    </div>

    <div class="right total">
      {{
        details?.orderTotalCurrentGross || 0
          | currency: "GBP" : "symbol" : "1.2-2"
      }}
    </div>
  </section>

  <section class="section card note-block" *ngIf="hasOrderComment">
    <h4 class="section-title">
      Customer note
      <button
        type="button"
        class="linkish copy-btn"
        (click)="copy(orderComment)"
      >
        Copy
      </button>
    </h4>
    <p class="note-text">{{ orderComment }}</p>
  </section>

  <!-- (Optional) Internal note -->
  <section class="section card note-block internal" *ngIf="hasTenantComment">
    <h4 class="section-title">
      Internal note
      <button
        type="button"
        class="linkish copy-btn"
        (click)="copy(tenantComment)"
      >
        Copy
      </button>
    </h4>
    <p class="note-text">{{ tenantComment }}</p>
  </section>

  <!-- Customer / Delivery -->
  <section
    class="section card customer-details"
    *ngIf="details?.phoneNumber || details?.orderType === 'delivery'"
  >
    <h4 class="section-title">Customer Details</h4>

    <div
      class="customer-details-grid"
      [class.has-address]="details?.orderType === 'delivery'"
    >
      <div class="customer-info-box phone-box" *ngIf="details?.phoneNumber">
        <span class="field-label">Phone number</span>
        <span class="phone-value">+{{ details?.phoneNumber }}</span>
      </div>

      <div
        class="customer-info-box address-box"
        *ngIf="details?.orderType === 'delivery'"
      >
        <span class="field-label">Delivery address</span>

        <address class="addr">
          {{ details?.delivery?.address_line_1
          }}<br *ngIf="details?.delivery?.address_line_2" />
          <span *ngIf="details?.delivery?.address_line_2">
            {{ details?.delivery?.address_line_2 }}<br />
          </span>
          {{ details?.delivery?.city }}, {{ details?.delivery?.county }}<br />
          {{ details?.delivery?.country }} {{ details?.delivery?.postal_code }}
        </address>
      </div>
    </div>
  </section>

  <!-- Items -->
  <section class="section card">
    <h4 class="section-title">
      Items -
      <span class="count-pill" *ngIf="totalItemsCount > 0">{{
        totalItemsCount
      }}</span>
    </h4>

    <ul class="items" *ngIf="(details?.details?.length || 0) > 0; else noItems">
      <li class="item-card" *ngFor="let it of details?.details || []">
        <div class="item-category" *ngIf="it.categoryName">
          {{ it.categoryName }}
        </div>

        <div class="row">
          <div class="name">
            <span class="qty">{{ it.itemQuantity }} ×</span>
            <span>{{ it.itemName }}</span>
          </div>
          <div class="price">
            {{
              it.itemTotalGrossOriginal | currency: "GBP" : "symbol" : "1.2-2"
            }}
          </div>
        </div>

        <!-- removed per request: individual item status + updated time -->

        <div class="extras" *ngIf="(it.extras?.length || 0) > 0">
          <div class="extras-title">Extras</div>
          <ul>
            <li *ngFor="let ex of it.extras">
              {{ ex.extraQuantity }} × {{ ex.extraName }}
              <span class="ex-price" *ngIf="ex.extraPrice">
                ({{ ex.extraPrice | currency: "GBP" : "symbol" : "1.2-2" }})
              </span>
            </li>
          </ul>
        </div>

        <div class="note" *ngIf="it.itemNote">
          <span class="note-label">Note:</span> {{ it.itemNote }}
        </div>
      </li>
    </ul>

    <ng-template #noItems>
      <div class="empty">No items found for this order.</div>
    </ng-template>
  </section>

  <!-- Footer CTAs (sticky) -->
  <section class="footer-ctas">
    <div class="cta-left">
      <button
        class="btn btn-decline-action"
        *ngIf="showAcceptDecline"
        (click)="decline()"
        [disabled]="actionBusy"
      >
        Decline
      </button>

      <button
        class="btn btn-refund-action"
        *ngIf="canRefund"
        (click)="onRefund()"
        [disabled]="actionBusy"
        title="Issue a full or partial refund"
      >
        Refund
      </button>
    </div>

    <div class="cta-right">
      <button
        type="button"
        class="btn btn-print-action"
        (click)="printReceipt()"
        [disabled]="!details"
      >
        Print Receipt
      </button>

      <button
        class="btn btn-accept-action"
        *ngIf="showAcceptDecline"
        (click)="acceptAndPrint()"
        [disabled]="actionBusy"
      >
        Accept
      </button>

      <button
        class="btn btn-start-prep-action"
        *ngIf="showStartPrep"
        (click)="startPrep()"
        [disabled]="actionBusy"
      >
        Start Prep
      </button>

      <button
        class="btn"
        [ngClass]="
          (details?.orderType || 'delivery') === 'collection'
            ? 'btn-ready-collection-action'
            : 'btn-send-delivery-action'
        "
        *ngIf="showSendDelivery"
        (click)="sendToDelivery()"
        [disabled]="actionBusy"
      >
        {{
          (details?.orderType || "delivery") === "collection"
            ? "Ready for Collection"
            : "Send to Delivery"
        }}
      </button>

      <button
        class="btn btn-complete-action"
        *ngIf="showComplete"
        (click)="complete()"
        [disabled]="actionBusy"
      >
        Complete
      </button>
    </div>
  </section>
</div>

<ng-template #loadingOrError>
  <div *ngIf="loading" class="loading">
    <div class="sk-line w60"></div>
    <div class="sk-line w80"></div>
    <div class="sk-line w40"></div>
  </div>
  <div *ngIf="!loading && error" class="error">{{ error }}</div>
</ng-template>
